import React, {useEffect} from "react";
import {FormControl, InputLabel, Select, MenuItem} from "@material-ui/core";

import {TaskDataLocationObject} from "common/flowmaster/types/data_location";
import {
  WorkflowTask,
  ActionDefinition,
} from "common/flowmaster/types/task_config";

interface ValueEditorProps {
  location: TaskDataLocationObject;
  priorTasks: WorkflowTask[];
  actionDefinitions: ActionDefinition[];
  onUpdateItem: (value: TaskDataLocationObject) => void;
  handleHasError?: (value: boolean) => void;
  disabled?: boolean;
}

const TaskValueEditor: React.FC<ValueEditorProps> = ({
  location,
  priorTasks,
  actionDefinitions,
  onUpdateItem,
  handleHasError,
  disabled = false,
}) => {
  const selectedTask = priorTasks.find(task => task.id === location.task);
  const actionDefinition =
    selectedTask &&
    actionDefinitions.find(
      actionDefinition => actionDefinition.key === selectedTask.action,
    );

  const error = !location.key;

  useEffect(() => {
    if (handleHasError) {
      handleHasError(error);
    }
  }, [error]);

  return (
    <FormControl disabled={disabled} variant="outlined" fullWidth>
      <InputLabel id="task-selector-label">Key</InputLabel>
      <Select
        labelId="task-selector-label"
        value={location.key}
        onChange={event =>
          onUpdateItem({...location, key: event.target.value as string})
        }
        label="Value"
        error={!location.key}
      >
        {Object.entries(actionDefinition?.result ?? {}).map(([key, type]) => (
          <MenuItem value={key} key={key}>
            {key} ({type})
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default TaskValueEditor;
